module.exports = __webpack_public_path__ + "static/media/img_56.0dd9cc67.png";